import type {
  TestInfoEndFontSchemaType,
  TestInfoEndSchemaType,
  TestInfoStartFontSchemaType,
  TestInfoStartSchemaType,
} from '@vedalib/editor/lib/brand'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { DEMO_MODE } from 'services/Store/Project/constants'

import DemoWrapper from '../../decorators/DemoWrapper'
import type { FCDemoType } from '../../elements.types'
import Element from './TestInfoElement'

const Start: FCDemoType<TestInfoStartSchemaType, TestInfoStartFontSchemaType> = ({
  styles,
  fonts,
  feedback,
}) => (
  <DemoWrapper center>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.testInfoStart.type}-demo`,
        type: CONFIG_ELEMENTS.testInfoStart.type,
        value: CONFIG_ELEMENTS.testInfoStart.defaultValue,
        font: {},
        style: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

const End: FCDemoType<TestInfoEndSchemaType, TestInfoEndFontSchemaType> = ({
  styles,
  fonts,
  feedback,
}) => (
  <DemoWrapper center>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.testInfoEnd.type}-demo`,
        type: CONFIG_ELEMENTS.testInfoEnd.type,
        value: CONFIG_ELEMENTS.testInfoEnd.defaultValue,
        font: {},
        style: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

export { Start, End }
